interface GetUnitProps {
  name: string;
  displayName: string;
  currencySymbol: string;
}

export const getUnit = ({ name, displayName, currencySymbol }: GetUnitProps): string => {
  const options = [
    { name: 'm2', unit: 'm²' },
    { name: 'price', unit: currencySymbol }
  ];

  const option = options.find(option => name.includes(option.name));
  if (option) {
    return option.unit;
  }

  // Splits on value inside parentheses
  const [, unit = ''] = displayName.split(/\(([^)]+)\)/);
  // The displayName contains the unit
  // For example, Volym (l)
  return unit;
};

interface GetUnitToShowProps {
  unit: string;
  value: string | number;
}

export const getUnitToShow = ({ unit, value }: GetUnitToShowProps) => {
  return value || value === 0 ? unit : '';
};
